import { PayloadAction, SliceCaseReducers } from '@reduxjs/toolkit'
import {
  BankingProductsByTypeParams,
  BankingProductsByTypeResponse,
  CashAccountItem,
  EditAliasPayload,
} from '@repo/accounts-types'
import { ApiResponse, createOperationSlice, GenericOperationState } from '@repo/core'

const initialState: GenericOperationState<ApiResponse<BankingProductsByTypeResponse> | null> = {
  payload: null,
  meta: { fetchState: 'initial' },
  error: false,
}

export const { actions: bankingProductsDataActions, reducer: bankingProductsDataReducer } =
  createOperationSlice<
    ApiResponse<BankingProductsByTypeResponse> | null,
    SliceCaseReducers<GenericOperationState<ApiResponse<BankingProductsByTypeResponse> | null>>,
    BankingProductsByTypeParams
  >({
    name: '@accounts/detail/read/bankingProducts',
    initialState,
    reducers: {
      updateAlias: (state, action: PayloadAction<EditAliasPayload>) => {
        if (state.payload && action.payload.productType === 'CASH') {
          const { alias, id } = action.payload
          const item = state.payload.data?.items.find((i) => i.id === id)
          if (item) {
            ;(item as CashAccountItem).alias = alias
          }
        }
      },
    },
  })
